import { render, staticRenderFns } from "./eDSMessageList.vue?vue&type=template&id=e46b942a"
import script from "./eDSMessageList.vue?vue&type=script&lang=js"
export * from "./eDSMessageList.vue?vue&type=script&lang=js"
import style0 from "./eDSMessageList.vue?vue&type=style&index=0&id=e46b942a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports